import { ReactSession } from "../../lib/secure_reactsession.js";
import React, { useState, useEffect } from "react";
import ResearcherDashboard from "./researcher.js";
import TesterDashboard from "./tester.js";
import ChooseWorkspaces from "./choose-workspaces.js";
import { getPageTitle } from "../../lib/pageTitle.js";

export default function Dashboard() {
  ReactSession.setStoreType("localStorage");
  const [user, setUser] = useState({ role: "" });

  useEffect(() => {
    document.title = getPageTitle("Your dashboard");
    const sessionUser = ReactSession.get("user");
    setUser(sessionUser || { role: "" });
  }, []);

  const loginUserDashboard = () => {
    if (user.role === "Tester") {
      return <TesterDashboard />;
    } else if (user.role === "Researcher") {
      return <ChooseWorkspaces />;
    } else if (user.role === "Collaborator") {
      return <ResearcherDashboard />;
    } else {
      return <></>;
    }
  };

  return <>{loginUserDashboard()}</>;
}
